import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import Footer from '../components/Footer';
import MobileNav from '../components/MobileNav';

/**
 * Shared layout for legal/policy pages: header + max-width prose container + footer.
 * Children render inside the prose container.
 */
const LegalLayout = ({ title, lastUpdated, children, testId = 'legal-page' }) => {
  return (
    <div className="min-h-screen bg-sand-50 flex flex-col" data-testid={testId}>
      <header className="glass-header sticky top-0 z-50 bg-sand-50/80 border-b border-[#E8E1D5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 sm:py-5 flex justify-between items-center">
          <BrandLogo size="md" linkTo="/" />
          <MobileNav
            links={[
              { to: '/instant-pricing', label: 'Instant Pricing', className: 'text-sm tracking-[0.2em] uppercase font-bold text-text-secondary hover:text-text-primary transition-colors' },
            ]}
            actions={[
              { to: '/login', label: 'Login', className: 'text-sm tracking-[0.2em] uppercase font-bold text-text-secondary hover:text-text-primary transition-colors' },
            ]}
          />
        </div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-8 py-10 sm:py-16">
        <div className="mb-6">
          <Link to="/" className="text-xs tracking-[0.2em] uppercase font-bold text-text-secondary hover:text-brand-primary" data-testid="legal-home-link">
            ← Back to Home
          </Link>
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tighter font-light leading-none text-text-primary mb-3">
          {title}
        </h1>
        {lastUpdated && (
          <p className="text-xs text-text-secondary tracking-[0.15em] uppercase mb-8" data-testid="legal-last-updated">
            Last updated: {lastUpdated}
          </p>
        )}

        <div className="prose prose-sm max-w-none text-text-primary leading-relaxed [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-text-primary [&_h3]:font-bold [&_h3]:text-base [&_h3]:mt-5 [&_h3]:mb-2 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-3 [&_li]:mb-1 [&_strong]:font-bold [&_a]:text-brand-primary [&_a]:underline">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalLayout;
